import { money, number, percentage } from '../../util/formatters'
import React from 'react'
import { Calculation } from './Calculation'
import { get, getSuffix } from '../../util/kdp_cols'

interface CacCellProps {
    cac: number
    orders: number
    cost: number
}

export const CacCell = (v: CacCellProps, extra: any) => {
    const suffix = getSuffix(extra.col?.key)
    const g = (key: string) => get(v, key, suffix)
    let cac = g('cac')

    const lines = [
        { description: 'Spend', value: money(g('cost')) ?? '' },
        { description: '÷ Orders', value: number(g('orders')) ?? '' },
        { description: 'CAC', value: money(cac) ?? '' },
    ]

    return <Calculation lines={lines}>{money(cac)}</Calculation>
}

interface BlendedCacCellProps {
    blended_cac: number
    adjusted_orders: number
    cost: number
}

export const BlendedCacCell = ({ blended_cac, adjusted_orders, cost }: BlendedCacCellProps) => {
    const lines = [
        { description: 'Spend', value: money(cost) ?? '' },
        { description: '÷ Adjusted Orders', value: number(adjusted_orders) ?? '' },
        { description: 'Blended CAC', value: money(blended_cac) ?? '' },
    ]

    return <Calculation lines={lines}>{money(blended_cac)}</Calculation>
}
